import store from '../store'

export default {
    data() {
        return {
            refreshing: false,
            registration: null,
            updateCheck: false,
        }
    },

    created() {
        document.addEventListener('swUpdated', this.updateAvailable, {once: true});
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (this.refreshing) return;
            this.refreshing = true;
        })
    },

    methods: {
        updateAvailable(event) {
            this.registration = event.detail;
            this.updateCheck = true;
        },
        refreshApp() {
            this.updateCheck = false;
            store.state.loading = true;
            //if (!this.registration || !this.registration.waiting) return;
            //this.registration.waiting.postMessage({type: 'SKIP_WAITING'});
            setTimeout(()=>{
                window.location.reload()
            }, 1000);
        },
    },
}